// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"544def9f","522":"9040ec58"}[chunkId] + ".chunk.js";
};